/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import _ from 'underscore';

function GridNameCell(props) {
  const {
    item,
    i18n,
    rowClass,
    GoalCategoryFilterStore,
    router,
    instrumentationLog,
  } = props;

  const nameCellData = useMemo(() => ({
    status: item.status,
    name: item.name,
    typeName: item.typeName,
    campaignType: item.campaignType,
    rawStatus: item.rawStatus,
    category: item.category,
  }), [item]);

  const isAccount = useMemo(() => item.typeName === 'Account', [item]);
  const { AccountActivityStatus } = Constants;

  const statusIcon = useMemo(() => {
    if (isAccount) {
      switch (nameCellData.status) {
        case AccountActivityStatus.Errors:
          return (<div className="account-error-icon icon-error" />);
        case AccountActivityStatus.Deleted:
          return (<div className="account-deleted-icon" />);
        case AccountActivityStatus.Enabled:
          return (<div className="account-enabled-icon icon-success" />);
        default:
          return (<div className="account-enabled-icon icon-success" />);
      }
    } else {
      return (<div className="status statusEnabled_icon" />);
    }
  }, [AccountActivityStatus.Deleted, AccountActivityStatus.Enabled, AccountActivityStatus.Errors, isAccount, nameCellData.status]);

  const navigateToConversionGoals = useCallback(() => {
    if (router) {
      if (instrumentationLog) {
        instrumentationLog.GridNameClicked(nameCellData.name);
      }
      router.navigateToRoute('conversiongoals');
    }
  }, [instrumentationLog, nameCellData.name, router]);

  const updateFilterAndRoute = useCallback(() => {
    if (GoalCategoryFilterStore) {
      GoalCategoryFilterStore(nameCellData.category);
    }
    navigateToConversionGoals();
  }, [GoalCategoryFilterStore, nameCellData.category, navigateToConversionGoals]);
  return (
    <div className={classNames(
      'name-cell',
      'conversion-goals-entity-name',
      rowClass
    )}
    >
      <div className="status">
        {statusIcon}
      </div>
      <a
        title={item.hideToolTip ? '' : item.name}
        aria-label={i18n.getString(`${item.rawStatus} {{entity}}`)}
        entity={nameCellData.name}
        onClick={updateFilterAndRoute}
      >{nameCellData.name}
      </a>
    </div>
  );
}

GridNameCell.propTypes = {
  item: PropTypes.shape({
    status: PropTypes.string,
    name: PropTypes.string,
    category: PropTypes.string,
    typeName: PropTypes.string,
    campaignType: PropTypes.string,
    rawStatus: PropTypes.string,
    hideToolTip: PropTypes.bool,
  }),
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  rowClass: PropTypes.string,
  GoalCategoryFilterStore: PropTypes.func,
  router: PropTypes.shape({
    navigateToRoute: PropTypes.func,
  }),
  instrumentationLog: PropTypes.shape({
    GridNameClicked: PropTypes.func,
  }),
};
GridNameCell.defaultProps = {
  item: {},
  rowClass: '',
  GoalCategoryFilterStore: _.noop,
  router: {
    navigateToRoute: _.noop,
  },
  instrumentationLog: {
    GridNameClicked: _.noop,
  },
};

export default GridNameCell;
